import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-copy',
  templateUrl: './icon-copy.component.html',
  styleUrls: ['./icon-copy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCopyComponent {}
